import { useTranslations } from "next-intl";

import { ActionsDisclosure } from "@/components/sidebar/ActionsDisclosure";

import { MarimoPackages } from "./MarimoPackages";

import type { DocumentModel } from "@/models/DocumentModel";

export function MarimoPackagesPanel({ doc }: { doc: DocumentModel }) {
  const t = useTranslations("sidebar.blocks.packages");
  return (
    <ActionsDisclosure
      data-panel="marimo_packages"
      title={t("title")}
      disclosureProps={{ defaultOpen: false }}
      disclosurePanelProps={{ className: "-mt-1.25" }}
    >
      <MarimoPackages doc={doc} />
    </ActionsDisclosure>
  );
}
